import { Button, EmptyState } from '@gestao/ui'
import { TriangleAlert } from 'lucide-react'
import { useEffect } from 'react'
import { useRouteError } from 'react-router'

import * as t from '../i18n/pt-BR'
import { reportClientError } from '../lib/client-errors'

/** Falha inesperada ao renderizar uma rota: explica e oferece recarregar. */
export function RouteError() {
  const error = useRouteError()
  if (import.meta.env.DEV) console.error(error)
  // Erro de rota também vai para /client-errors (limite de 5 por sessão).
  useEffect(() => {
    reportClientError(error)
  }, [error])

  return (
    <main className="grid min-h-dvh place-items-center bg-canvas px-6">
      <EmptyState
        icon={<TriangleAlert />}
        title={
          <span role="heading" aria-level={1}>
            {t.errors.routeTitle}
          </span>
        }
        description={t.errors.routeDescription}
      >
        <Button onClick={() => window.location.reload()}>{t.errors.reload}</Button>
      </EmptyState>
    </main>
  )
}
